// extracted by mini-css-extract-plugin
module.exports = {"cls-1":"red-icon-m__cls-1__3Bkt4"};